/** US-408 AC-1: zapamiętany wybór osoby w agendzie – na tym urządzeniu (tylko wygoda, bez gwarancji zapisu). */
const key = (slug: string) => `koderek.activePerson.${slug}`;

export function readActivePerson(slug: string): string | null {
  try {
    return window.localStorage.getItem(key(slug));
  } catch {
    return null;
  }
}

export function saveActivePerson(slug: string, participantId: string): void {
  try {
    window.localStorage.setItem(key(slug), participantId);
  } catch {
    // Prywatne okno albo zablokowany magazyn – wybór po prostu nie zostanie zapamiętany.
  }
}
